<template>
  <el-table-column
    prop="eu_tax_number"
    sortable="custom"
    label="EU adószám"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.company.eu_tax_number }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'eu_tax_number',
};
</script>
